export default "__VITE_ASSET__b8a3f6b8__"